// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_5b-6";
export var headerCell = "_5b-2";
export var loadingStateContent = "_5b-8";
export var rowWrapper = "_5b-4";
export var stickyAggregationCell = "_5b-b";
export var stickyAggregationRow = "_5b-7";
export var stickyColumnCell = "_5b-a";
export var stickyColumnHeaderCell = "_5b-9";
export var table = "_5b-1";
export var virtualRowWrapper = "_5b-5";
export var virtualTableContainer = "_5b-0";
export var white = "_5b-3";